<!-- <div class="container-top flex items-center justify-between">
  <div class="flex">
    <h1>Orders List</h1>
  </div>
  <div class="filters flex">
    <div class="text-3xl text-white" [hidden]="!showFilterBt">
      <mat-icon (click)="showFilterBt = false">filter_alt</mat-icon>
    </div>
    <div
      class="container-selects flex justify-between gap-2"
      [hidden]="showFilterBt"
    >
      @if (checkboxFilters.service.children?.length) {
        <app-checkbox-select
          [data]="checkboxFilters.service"
          [placeholder]="'Service'"
          [name]="'Service'"
        />
      }

      @if (checkboxFilters.status.children?.length) {
        <app-checkbox-select
          [data]="checkboxFilters.status"
          [placeholder]="'Status'"
          [name]="'Status'"
        />
      }

      @if (checkboxFilters.address.children?.length) {
        <app-checkbox-select
          [data]="checkboxFilters.address"
          [placeholder]="'Address'"
          [name]="'Address'"
        />
      }
    </div>
  </div>
</div> -->

<div class="my-4 w-full rounded-xl bg-white">
  <div class="container-top flex px-6 pt-4">
    <div class="flex justify-between gap-2" [hidden]="showFilterBt">
      @if (checkboxFilters.service.children?.length) {
        <app-checkbox-select
          [data]="checkboxFilters.service"
          [placeholder]="'Service'"
          [name]="'Service'"
        />
      }

      @if (checkboxFilters.status.children?.length) {
        <app-checkbox-select
          [data]="checkboxFilters.status"
          [placeholder]="'Status'"
          [name]="'Status'"
        />
      }

      @if (checkboxFilters.address.children?.length) {
        <app-checkbox-select
          [data]="checkboxFilters.address"
          [placeholder]="'Address'"
          [name]="'Address'"
        />
      }

      <div class="text-3xl text-white" [hidden]="!showFilterBt">
        <mat-icon (click)="showFilterBt = false">filter_alt</mat-icon>
      </div>
    </div>
  </div>

  <app-table-orders
    [data]="data"
    [loading]="loading"
    [filterStatus]="this.checkboxFilters.status.selectedChildren"
    [filterService]="this.checkboxFilters.service.selectedChildren"
    [filterAddress]="this.checkboxFilters.address.selectedChildren"
    (filterRemove)="removeFromFilter($event.type, $event.item.attrs.value)"
    (selectOrder)="selectOrder.emit($event)"
  ></app-table-orders>
</div>
